import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import styles from "./styles.scss";
import EventInfo from "./EventInfo";
import { eventDetails as getPortalEventDetails } from "redux/modules/portal/selectors";
import { getEventFields } from "../../selectors";
import { getters } from "../../model";

const decorate = R.compose(
  connect((state, props) => ({
    data: getters.data(state),
    lockedFieldIds: getters.lockedFieldIds(state),
    updatedFieldValues: getters.updatedFieldValues(state),
    fields: getEventFields(state, props),
    eventDetails: getPortalEventDetails(state, props)
  }))
);

const Layout = ({
  data = {},
  updatedFieldValues = {},
  fields,
  eventDetails,
  lockedFieldIds
}) => {
  const { name: eventInfoTitle } = eventDetails || {};
  return (
    <div className={styles.container}>
      <div className={styles.subContainer}>
        <EventInfo
          {...{
            data,
            updatedFieldValues,
            lockedFieldIds,
            fields,
            eventInfoTitle
          }}
        />
      </div>
    </div>
  );
};

export default decorate(Layout);
